import React from "react";
import { Box } from "@mui/material";
import Typography from "components/basic/typography";

interface ProfileRowProps {
  label: string;
  value?: React.ReactNode;
}

const ProfileRow: React.FC<ProfileRowProps> = ({ label, value }) => (
  <Box display="flex" flexWrap="wrap" columnGap={2} py={0.5}>
    <Typography variant="body2" style={{ minWidth: 170, fontWeight: 600 }}>
      {label}
    </Typography>
    <Typography variant="body2" style={{ wordBreak: "break-word" }}>
      {value || "—"}
    </Typography>
  </Box>
);

export default ProfileRow;
